/**
 * Category Context
 *
 * Manages category-related state for the Items feature.
 * Replaces category-related state from old AppContext.
 */

import { createContext } from "react";
import { Category } from "../../domain/entities/Category";

export interface CategoryContextType {
  categories: Category[];
  isLoading: boolean;
  error: Error | null;
  addCategory: (
    name: string,
    parentId: string | null,
    level: number,
  ) => Promise<void>;
  addCategories: (
    categories: {
      id: string;
      name: string;
      parentId: string | null;
      level: number;
    }[],
  ) => Promise<void>;
  removeCategory: (id: string) => Promise<void>;
  updateCategory: (id: string, name: string) => Promise<void>;
  refreshCategories: () => Promise<void>;
}

export const CategoryContext = createContext<CategoryContextType | undefined>(
  undefined,
);
CategoryContext.displayName = "CategoryContext";
